import { render, staticRenderFns } from "./cmsEntryAgreement.vue?vue&type=template&id=2fafa48c&scoped=true"
import script from "./cmsEntryAgreement.vue?vue&type=script&lang=js"
export * from "./cmsEntryAgreement.vue?vue&type=script&lang=js"
import style0 from "./cmsEntryAgreement.vue?vue&type=style&index=0&id=2fafa48c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fafa48c",
  null
  
)

export default component.exports